import TemplateUpdateDrawer from "./TemplateUpdateDrawer"

export default TemplateUpdateDrawer
